<body>
  <router-outlet></router-outlet>

  <div class="overlay" *ngIf="loading$ | async"></div>
  <div class="loading-screen" *ngIf="loading$ | async">
    <img class="loader" width="200" height="200" src="https://aeroguestblobstorageprod.blob.core.windows.net/images/MakeTimeForWhatMatters.png" />
  </div>
</body>
